import { createContext, useContext, useReducer } from "react";
import { initialState, productDetailInformationReducer } from "../reducer/ProductDetailInformationReducer";

const ProductDetailInformationStateContext = createContext();
const ProductDetailInformationDispatchContext = createContext();

export const ProductDetailInformationProvider = ({ children }) => {
  const [state, dispatch] = useReducer(productDetailInformationReducer, initialState);

  return (
    <ProductDetailInformationStateContext.Provider value={state}>
      <ProductDetailInformationDispatchContext.Provider value={dispatch}>
        {children}
      </ProductDetailInformationDispatchContext.Provider>
    </ProductDetailInformationStateContext.Provider>
  )
}

export const useProductDetailInformationState = () => {
  const context = useContext(ProductDetailInformationStateContext);

  if (!context) throw Error('useProductDetailInformationState는 ProductDeliveryProvider 내에서 사용해야 합니다.');
  return context;
}

export const useProductDetailInformationDispatch = () => {
  const context = useContext(ProductDetailInformationDispatchContext);

  if (!context) throw Error('useProductDetailInformationDispatch는 ProductDeliveryProvider 내에서 사용해야 합니다.');
  return context;
}